import GET_MY_ACTIVE_ORDERS from 'graph/orders/get-my-orders-query';
import GET_MY_LICENSE_USAGE from 'graph/license/get-my-license-usage';
import GET_MY_ORGANIZATION_NAMES_CLASSROOMS_AND_MASTER_CODES from 'graph/composite/get-my-organization-names-classrooms-and-master-codes-query';
const activeOrders = {
  query: GET_MY_ACTIVE_ORDERS,
  variables: {
    where: {
      completed: false
    }
  }
};
export const getMyOrdersMutationCacheUpdate = (userId?: number): any => {
  if (typeof userId !== 'number') {
    return {
      refetchQueries: [activeOrders]
    };
  }
  return {
    refetchQueries: [
      activeOrders,
      {
        query: GET_MY_ORGANIZATION_NAMES_CLASSROOMS_AND_MASTER_CODES,
        variables: { userId },
        errorPolicy: 'all'
      }
    ]
  };
};

export const getBulkAssignAvailableCacheUpdate = (userId?: number): any => {
  if (typeof userId !== 'number') {
    return {
      refetchQueries: [activeOrders, { query: GET_MY_LICENSE_USAGE }]
    };
  }

  return {
    refetchQueries: [
      activeOrders,
      { query: GET_MY_LICENSE_USAGE },
      {
        query: GET_MY_ORGANIZATION_NAMES_CLASSROOMS_AND_MASTER_CODES,
        variables: { userId },
        errorPolicy: 'all'
      }
    ]
  };
};
